export { default } from '@shikijs/langs/haskell'
